// src/services/PatientLabTestService.js

import apiClient from "./apiClient";
const API_URL = `/ipd-lab-tests`; // Use relative path since apiClient has baseURL

export const createLabTest = async (labTestData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, labTestData);
  return response.data;
};

export const updateResults = async (labData) => {
  // apiClient will automatically add organizationId via interceptor
  const updates = Array.isArray(labData) ? labData : [labData];
  if (updates.length === 0) return [];

  // Update one record per request. Batch updates can trigger Hibernate flush
  // conflicts on organization-specific tables (OptimisticLockException → 500).
  const results = [];
  for (const item of updates) {
    const response = await apiClient.put(`${API_URL}/update-results`, [item]);
    const savedRows = Array.isArray(response.data)
      ? response.data
      : response.data
        ? [response.data]
        : [];
    results.push(...savedRows);

    try {
      const { syncSampleTransactionAfterIpdResult } = await import("./sampleTransactionService");
      await syncSampleTransactionAfterIpdResult(item, savedRows[0] || response.data);
    } catch (sampleError) {
      console.warn(
        "[PatientlabTestService] Sample transaction result sync failed:",
        sampleError?.message || sampleError
      );
    }
  }
  return results;
};

export const getByLabId = async (labId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/lab/${labId}`);
  return response.data;
};

export const getLabTestsByAdmissionId = async (admissionId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-admission/${admissionId}`);
  return response.data;
};

export const getByPatientIdAndLabId = async (patientId, labId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/lab/${patientId}/${labId}`);
  return response.data;
};

// Helper to get all IPD lab tests (for card view)
export const getAllIPDLabTests = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(API_URL);
  return response.data;
};

// Update sample collection status
export const updateSampleCollection = async (id) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.put(`${API_URL}/${id}/collected`);
  return response.data;
};

// Update reject status
export const updateRejectStatus = async (id) => {
  // apiClient will automatically add organizationId via interceptor
  // Pass empty body to match other reject endpoints
  const response = await apiClient.put(`${API_URL}/${id}/reject`, {});
  return response.data;
};

export default {
  createLabTest,
  updateResults,
  getLabTestsByAdmissionId,
  getByPatientIdAndLabId,
  getAllIPDLabTests,
  updateSampleCollection,
  updateRejectStatus,
} 